import { ErrorRoutePath } from "app/constants/routePaths";
import CalendarScreen from "app/screens/calendar/CalendarScreen";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";
import { Redirect } from "expo-router";

export default function CalendarPage() {
  const { checkPermission } = usePermissionCheck();

  if (!checkPermission(PermissionsEnums.VIEW_CALENDAR_EVENT))
    return <Redirect href={ErrorRoutePath} />;

  return <CalendarScreen />;
}
